import { Outlet } from "react-router-dom";

const Riders = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Riders;